<div class="jeopary-mode-grid">
  <div class="jeopardy-question-panel settings-panel">
    <h2 class="settings-title">{{i18n.str('challengeu.settings_title','Settings')()}}</h2>
    <div>
      <h3 class="category-title">{{i18n.str('challengeu.settings_music_sounds','Music & Sounds')()}}</h3>
      <p class="category-value">
        <a href="#" [ngClass]="{ 'neon-round xs': !soundsService.musicOff}" (click)="setMusic($event)">
          <img class="settings-icon" src="assets/app-branding/img/icons/Icons-music.png"
               [alt]="i18n.str(soundsService.soundsOff ? '': 'challengeu.settings_music_sounds','Music on/off')() " />
        </a>
        <a href="#" [ngClass]="{ 'neon-round xs': !soundsService.soundsOff}" (click)="setSoundsFX($event)">
          <img class="settings-icon" src="assets/app-branding/img/icons/Icons-sounds.png"
               [alt]="i18n.str(soundsService.soundsOff ? '': 'challengeu.settings_music_sounds','Sounds on/off')() " />
        </a>
      </p>
    </div>
    <hr>
    <div>
      <h3 class="category-title">{{i18n.str('challengeu.settings_language','Language')()}}</h3>
      <div class="lang-container">
        <a href="#" (click)="selectLanguage($event, -1)"><i class="fa fa-caret-left"></i></a>
        <div style="overflow: hidden;">
          <div class="language-list" [style.transform]="langStyle">
            @for (language of languages; track language.isoCode4Letters) {
            <div #languageItem class="language-item">{{language.name}}</div>
            }
          </div>
        </div>
        <a href="#" (click)="selectLanguage($event, 1)"><i class="fa fa-caret-right"></i></a>
      </div>
    </div>
    <hr>
    <div>
      <h3 class="category-title">{{i18n.str('challengeu.settings_country','Country')()}}</h3>
      <div class="category-value">
        <input type="text" class="country-input" [(ngModel)]="searchQuery" [ngModelOptions]="{standalone: true}"
               placeholder="{{placeholder}}" (focus)="onCountryInputFocus(true)" (focusout)="onCountryInputFocus(false)"
               (ngModelChange)="filterCountries($event)">
      </div>
      <div class="suggestion-list">
        @for (item of countriesSuggestions; track item) {
        <a class="neon-yellow" href="#" (click)="selectCountry($event, item)">{{item.value}}</a>
        }
      </div>
    </div>
    <hr>
    <br>
    <div class="inline-buttons space-evenly">
      <p class="jeopardy-button primary">
        <a class="neon" href="#" title="{{i18n.str('challengeu.switch_user','SWITCH USER')()}}"
           (click)="switchUser($event)">
          {{i18n.str('challengeu.switch_user','SWITCH USER')()}}
        </a>
      </p>
      <p class="jeopardy-button primary">
        <a href="#" title="{{i18n.str('challengeu.dialog_save','Save')()}}" (click)="saveChanges($event)">
          {{i18n.str('challengeu.main_switch_user','SAVE')()}}
        </a>
      </p>
    </div>
    @if (changesSaved) {
    <div class="changes-saved">
      <span>{{i18n.str('challengeu.settings_updated','Profile details updated')()}}</span>
    </div>
    }
  </div>
  <div class="settings-back">
    <p class="jeopardy-button primary">
      <a href="#" title="{{i18n.str('challengeu.back_main_menu','BACK TO MAIN MENU')()}}" routerLink="/main-menu">
        {{i18n.str('challengeu.back_main_menu','BACK TO MAIN MENU')()}}
      </a>
    </p>
  </div>

</div>
